// mui 5
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

export const BannerContainer = styled(Paper)(({ theme, image }) => ({
  width: '100%',
  // backgroundColor: theme.palette.primary.main,
  backgroundColor: "#eee",
  color: theme.palette.grey[900],
  backgroundSize: "null",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",


  // mobile 
  [theme.breakpoints.down("sm")]: {
    backgroundImage: null,
  },
  // desktop
  [theme.breakpoints.up("sm")]: {
    backgroundImage: `url(${image})`,
    height: "250px",
  },
}));
